import { push } from 'react-router-redux';

import addCookieWithConsent from '../../pattern_utilities/addCookieWithConsent';

import {
  tryToGetMyPatterns, 
  tryToGetOfficialPatterns, 
  tryToFetchMyTeams, 
  addVerifyEmailToast, 
  saveToken,
  receiveLoginSuccess
} from '../actions.export.js';

var Cookies = require('js-cookie');
var pf_config = require('../../pf_config.json');

const getUrlParams = () => {
  var urlParams;
  var match,
      pl     = /\+/g,  // Regex for replacing addition symbol with a space
      search = /([^&=]+)=?([^&]*)/g,
      decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
      query  = window.location.search.substring(1);

  urlParams = {};
  while (match = search.exec(query))
     urlParams[decode(match[1])] = decode(match[2]);

  return urlParams;
}


////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// LOGIN MFA
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestLoginMFA = credentials => {
  return {
    type: 'REQUEST_LOGIN_MFA',
    data: {
      lastSubmit: credentials
    }
  }
}

export const receiveLoginMFASuccess = data => ({
  type: 'RECEIVE_LOGIN_MFA_SUCCESS',
  data
})

export const receiveLoginMFAFail = data => ({
  type: 'RECEIVE_LOGIN_MFA_FAIL',
  data
})

export const tryToLoginMFA = packet => dispatch => {
  dispatch(requestLoginMFA(packet));

  return fetch('/api/users/login/mfa', {
      method: 'post',
      body: JSON.stringify(packet),
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + Cookies.get(process.env.REACT_APP_COOKIE_MFA_AUTH)
      }
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      var urlParams = getUrlParams();

      Cookies.remove(process.env.REACT_APP_COOKIE_MFA_AUTH);

      dispatch(receiveLoginMFASuccess(json));
      dispatch(receiveLoginSuccess(json));
      dispatch(saveToken(json.token));
      
      setTimeout((e)=>{
        dispatch(tryToGetMyPatterns());
        dispatch(tryToFetchMyTeams());
        dispatch(tryToGetOfficialPatterns());
      }, 250)

      // if not yet email_verified throw a toast out
      let parsed_token = JSON.parse(window.atob(json.token.split('.')[1]));
      let email_verified = parsed_token.email_verified;
      if(!email_verified){
        dispatch(addVerifyEmailToast());
      }
      
      if(urlParams.after){
        return dispatch(push(window.atob(urlParams.after)));
      }

      if(window.location.pathname === '/login'){
        return dispatch(push('/new/drawing'));
      }

    })
    .catch(e => {
      dispatch(receiveLoginMFAFail({errors:e, lastSubmit: packet}));
    })
}



// WEBPACK FOOTER //
// ./src/actions/user/a.u.POST.login.mfa.js